/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [footer.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 29.03.19 09:12
 */
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import he from 'he';
import {ConfigurationContext} from "../configuration/configuration";
import {ExpandMoreIcon, fs_large} from "../navigation/icons/nav-icons";

const renderFooterAsHTML = (text) => {
    return text.map((entry,index) => <p key={index} ref={ref => {
        if (ref) ref.innerHTML = he.decode(entry);
    }}>{entry}</p>)
};

const Footer = (props) => {
    let footerBody;
    const {Copy, Lang} = useContext(ConfigurationContext);

    const handleOnClick = event => {
        event.preventDefault();
        footerBody && footerBody.classList.toggle('footer-container-body-invisible');
    }

    return <div className="row ">
        <div className="col-sm-12">
            <div className="footer-container">
                <footer className="footer">
                    <div className="footer-navigation">
                        <div className="footer-nav-logo">{Copy && Copy.legalFullName}</div>
                        <div className="footer-nav-entry"><Link
                            to="/public/page/imprint">{Lang.nav.header.imprint}</Link></div>
                        <div className="footer-nav-entry"><Link
                            to='/public/page/privacy-policy'>{Lang.nav.header.privacy}</Link>
                        </div>
                        <div className="btn-outline-light footer-nav-entry" onClick={handleOnClick}>
                            <ExpandMoreIcon size={fs_large}/></div>
                    </div>
                    <div className="footer-container-body footer-container-body-invisible"
                         ref={elem => footerBody = elem}>
                        {Copy && renderFooterAsHTML(Copy.footer.text)}
                        {Copy && renderFooterAsHTML(Copy.footer.copyright)}
                    </div>
                    <div className="author flex-row-reverse">
                        © 2018-2026 London, Munich, Zürich - marcelo.krebber@gmail.com
                    </div>
                </footer>
            </div>
        </div>
    </div>

};

export default Footer;